import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL, LOCALSTORAGES } from "../constants/constant";

// export const baseApi = createApi({
//   reducerPath: "rootApi",
//   baseQuery: fetchBaseQuery({
//     baseUrl: API_BASE_URL,

//     prepareHeaders: (headers) => {
//       const token = localStorage.getItem(LOCALSTORAGES.TOKEN);
//       if (token) {
//         headers.set("token", `${token}`);
//       }
//       return headers;
//     },
//   }),
//   tagTypes: [
//     "Campaigns",
//     "Tasks",
//     "Users",
//     "Profile",
//     "SubAdmin",
//     "TasksAnalytics",
//     "UsersAnalytics",
//     "CampaignsAnalytics",
//   ],

//   endpoints: () => ({}),
// });

// Step 1: Normal baseQuery with token injection
const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem(LOCALSTORAGES.TOKEN);
    if (token) {
      headers.set("token", token);
    }
    return headers;
  },
});

// Step 2: Wrapper to handle 401 logout
let isRedirecting = false;

const baseQueryWithReAuth: typeof rawBaseQuery = async (
  args,
  api,
  extraOptions,
) => {
  // Skip dashboard/query API calls if no token (prevents calls on login page)
  // Allow mutations (login, OTP, forgot password) to go through without token
  const token = localStorage.getItem(LOCALSTORAGES.TOKEN);
  const isMutation =
    typeof args === "object" &&
    args !== null &&
    "method" in args &&
    (args as any).method !== "GET";

  if (!token && !isMutation && api.type === "query") {
    return {
      error: {
        status: 401,
        data: { responseMessage: "Not authenticated" },
      },
    };
  }

  const result = await rawBaseQuery(args, api, extraOptions);

  // Handle token expiry (401) - only redirect for authenticated requests
  if (result.error && result.error.status === 401 && token && !isRedirecting) {
    isRedirecting = true;
    localStorage.removeItem(LOCALSTORAGES.TOKEN);
    window.location.href = "/login";
  }

  return result;
};

// Step 3: Create API with wrapper
export const baseApi = createApi({
  reducerPath: "rootApi",
  baseQuery: baseQueryWithReAuth,
  tagTypes: [
    "Campaigns",
    "Tasks",
    "Users",
    "Profile",
    "SubAdmin",
    "TasksAnalytics",
    "UsersAnalytics",
    "CampaignsAnalytics",
    "Referral_Code",
    "Users_Referral_Code",
    "Codes",
  ],
  endpoints: () => ({}),
});

export default baseApi;
